import gql from 'graphql-tag';

const createTelegramConnectLinkMutation = gql`
  mutation CreateTelegramConnectLink($userId: MongoID) {
    createTelegramConnectLink(userId: $userId) {
      connectUrl
      expiresAt
    }
  }
`;

export default createTelegramConnectLinkMutation;
